import service from '@/services/facturacion/receptor'

const getDefaultState = () => ({
  receptores: [], // lista de receptores de búsqueda.
  receptor: {
    nombre: '',
    identificacion: { tipo: { id: '' }, numero: null },
    identificacionExtranjero: null,
    nombreComercial: null,
    ubicacion: {
      provincia: { id: null },
      canton: { id: null },
      distrito: { id: null },
      otrasSenas: null
    },
    telefono: { codigoPais: 506, numTelefono: null },
    actividades: [],
    otrasSenasExtranjero: null,
    correoElectronico: '',
    exoneracion: [] // lista de exoneraciones ligadas al receptor.
  },
  exoneracionSelected: {
    // exoneracion seleccionada del receptor para agregar en factura.
    tipoDocumentoEX1: { id: null },
    numeroDocumento: process.env.NODE_ENV === 'development' ? 'AL-00003160-26' : '', // para pruebas en dev: DGH-044-2019
    nombreInstitucion: '',
    fechaEmisionEX: null,
    tarifaExonerada: 13
  }
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_RECEPTOR: (state, obj) => {
    state.receptor = obj
    if (!obj.telefono) state.receptor.telefono = { codigoPais: 506, numTelefono: null }
  },
  RESET_RECEPTOR: state => {
    state.receptor = {
      nombre: '',
      identificacion: { tipo: { id: '' }, numero: null },
      identificacionExtranjero: null,
      nombreComercial: null,
      telefono: { codigoPais: 506, numTelefono: null },
      ubicacion: {
        provincia: { id: null },
        canton: { id: null },
        distrito: { id: null },
        otrasSenas: null
      },
      otrasSenasExtranjero: null,
      correoElectronico: '',
      actividades: [],
      exoneracion: []
    }
    state.exoneracionSelected = {
      tipoDocumentoEX1: { id: null },
      numeroDocumento: '',
      nombreInstitucion: '',
      fechaEmisionEX: null,
      tarifaExonerada: 13
    }
  },
  SET_RECEPTORES: (state, objs) => {
    // FIXME: Hay un bug cuando busca dos veces y retorna una lista, la segunda vez no se renderizan los resultados.
    state.receptores = objs.map(obj => {
      if (obj.telefono) {
        return obj
      }
      return { ...obj, telefono: { codigoPais: 506, numTelefono: null } }
    })
  },
  ADD_EXONERACION: (state, obj) => {
    state.exoneracionSelected = obj
  },
  SAVE_CHANGES: (state, obj) => {
    state.receptor = obj
  }
}

export const actions = {
  create: ({ commit, state }, item) => {
    commit('SET_RECEPTOR', {
      id: item.id,
      nombre: item.nombre,
      ...(!item.identificacionExtranjero && {
        identificacion: {
          tipo: {
            id: item.identificacion.tipo.id
          },
          numero: item.identificacion.numero
        }
      }),
      ...(item.telefono?.numTelefono && { telefono: item.telefono }),
      correoElectronico: item.correoElectronico,
      actividades: item.actividades,
      exoneracion: item.exoneracion ? item.exoneracion : [],
      ...(item.identificacionExtranjero && { identificacionExtranjero: item.identificacionExtranjero })
    })

    return service
      .create({
        id: item.id,
        nombre: item.nombre,
        ...(!item.identificacionExtranjero && {
          identificacion: {
            tipo: {
              id: item.identificacion.tipo.id
            },
            numero: item.identificacion.numero
          }
        }),
        ...(item.telefono?.numTelefono && { telefono: item.telefono }),
        correoElectronico: item.correoElectronico,
        actividades: item.actividades,
        ...(item.identificacionExtranjero && { identificacionExtranjero: item.identificacionExtranjero })
      })
      .then(result => {
        if (!state.receptor.id) state.receptor.id = result.id

        return result
      })
  },

  addExoneracion: ({ commit, state }, item) => {
    commit('ADD_EXONERACION', { ...item })

    return service
      .addExoneracion({
        id: state.receptor.id,
        exoneracion: state.exoneracionSelected
      })
      .then(result => {
        if (!state.receptor.exoneracion) {
          state.receptor.exoneracion = []
        }

        if (!state.receptor.exoneracion.find(e => e.numeroDocumento === state.exoneracionSelected.numeroDocumento)) {
          state.receptor.exoneracion.push(state.exoneracionSelected)
        }

        return result
      })
  },

  read: ({ commit }, id) => service.readById(id).then(result => commit('SET_RECEPTOR', result)),

  saveChanges: ({ commit }, item) => commit('SAVE_CHANGES', item),

  readByNombreIdentificacion: ({ commit }, nid) =>
    service.readByNombreIdentificacion(nid).then(result => {
      // si regresa solo 1 coincidencia, hace commit. si vienen +1, muestra al usuario las opciones.
      if (result.length === 1) {
        commit('SET_RECEPTOR', result[0])
        return 1 // solo 1 opcion para seleccionar.
      }
      if (result.length > 1) {
        commit('SET_RECEPTORES', result)
        return 'n' // hay n opciones para seleccionar
      }

      return 0 // no hay opciones.
    })
}
